<template>
  <section class="hero-stats">
    <div class="container">
      <h2 class="hero-stats__title">{{ t('heroStats.title') }}</h2>
      <p class="hero-stats__subtitle">{{ t('heroStats.subtitle') }}</p>
      <div class="hero-stats__grid">
        <div
          v-for="card in cards"
          :key="card.key"
          class="hero-stats__card"
          :style="`--card-gradient: ${card.gradient}`">
          <div class="hero-stats__card-bar" />
          <h3 class="hero-stats__card-title">{{ t(card.titleKey) }}</h3>
          <p class="hero-stats__card-desc">{{ t(card.descKey) }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const { t } = useI18n()

const cards = [
  {
    key: 'time',
    gradient: 'linear-gradient(90deg, #7c3aed 0%, #06b6d4 100%)',
    titleKey: 'heroStats.cards.time.title',
    descKey: 'heroStats.cards.time.desc',
  },
  {
    key: 'reco',
    gradient: 'linear-gradient(90deg, #06b6d4 0%, #f97316 100%)',
    titleKey: 'heroStats.cards.reco.title',
    descKey: 'heroStats.cards.reco.desc',
  },
  {
    key: 'free',
    gradient: 'linear-gradient(90deg, #f97316 0%, #ef4444 100%)',
    titleKey: 'heroStats.cards.free.title',
    descKey: 'heroStats.cards.free.desc',
  },
]
</script>

<style scoped>
.hero-stats {
  background: #151618;
  padding-block: var(--space-16);
}

.hero-stats__title {
  font-size: var(--text-2xl);
  font-weight: 700;
  text-align: center;
  line-height: var(--leading-snug);
  color: var(--text-primary);
  margin-bottom: var(--space-10);
}

.hero-stats__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-6);
}

/* Card */
.hero-stats__card {
  background: #1e1f22;
  border-radius: var(--radius-lg);
  padding: var(--space-6);
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  text-align: center;
  overflow: hidden;
  position: relative;
}

/* Barre colorée en haut */
.hero-stats__card-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--card-gradient);
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
}

.hero-stats__card-title {
  font-size: var(--text-base);
  font-weight: 700;
  color: var(--text-primary);
  line-height: var(--leading-snug);
  padding-top: var(--space-2);
}

.hero-stats__subtitle {
  font-size: var(--text-base);
  max-width: 560px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: var(--space-10);
}

.hero-stats__card-desc {
  font-size: var(--text-sm);
  color: var(--text-secondary);
  line-height: var(--leading-relaxed);
  font-style: italic;
}

/* Responsive */
@media (max-width: 768px) {
  .hero-stats__grid {
    grid-template-columns: 1fr;
    max-width: 380px;
    margin-inline: auto;
  }

  .hero-stats__title {
    font-size: var(--text-xl);
  }
}
</style>
